<template>
    <div id="app">
        <el-container>
            <div ref="scrollWrapper" class="scrollWrapper" style="overflow-y:auto;height:100vh;width: 100vw;">
                <Header />
                <Gns />
                <div class="hea50" style="height: 150px;"></div>
                <el-main ref="mainScrollBox" class="main-content">
                    <keep-alive include="Shop,addActivity,editActivity,addposition,editposition">
                        <router-view></router-view>
                    </keep-alive>

                    <Login v-if="showLogin" @logsuccess="jup" @regis="toregister" @forgets="toforgets"
                        @cal="closelogin">
                    </Login>
                    <Register @logss="showRe = false,showLogin=true"
                        @cal="showRe = false,showLogin = false,showfo=false" :type="identity" v-if="showRe"></Register>
                </el-main>

                <Forgets @logss="showfo = false,showLogin=true" @cal="showRe = false,showLogin = false,showfo=false"
                    v-if="showfo" :type="identity"></Forgets>
                <Footer />
            </div>
            <asides @scrolltop="stotop"></asides>
        </el-container>
    </div>
</template>
<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/footer.vue'
    import Gns from '@/components/gns.vue'
    import Login from "@/components/login.vue"
    import Register from "@/components/register.vue"
    import Forgets from "@/components/forgets.vue"
    import asides from "@/components/asidpart.vue"
    export default {
        components: {
            Header,
            Gns,
            Footer,
            Login,
            Register,
            Forgets,
            asides
        },
        created() {
            console.log("route", this.$route)
        },
        mounted() {
            this.$bus.$on('openLoginModal', () => {
                this.lastPageUrl = this.$route.fullPath
                this.showLogin = true
            })
            this.$bus.$on('closeLoginModal', () => {
                this.showLogin = false
            })
            this.$ysfInit().then(ysf => {
                // ysf('open')
            }).catch(e => {
                console.log(e)
            })
        },
        beforeDestroy() {
            // 销毁监听，防止内存泄漏
            this.$bus.$off('openLoginModal')
        },
        data() {
            return {
                showLogin: false,
                showRe: false,
                showfo: false,
                identity: 0,
                lastPageUrl: ""
            }
        },
        methods: {
            stotop() {
                const realDom = this.$refs.scrollWrapper
                console.log(realDom)
                if (realDom) {
                    this.smoothScrollTop(realDom)
                }
            },
            closelogin() {
                console.log(111)
                this.showLogin = false
            },
            smoothScrollTop(dom) {
                console.log("dom", dom.scrollTop)
                if (!dom) return
                const animate = () => {
                    if (dom.scrollTop > 0) {
                        dom.scrollTop -= 50
                        requestAnimationFrame(animate)
                    }
                }
                animate()
            },
            jup() {
                if (this.lastPageUrl && this.lastPageUrl !== '/') {
                    // 方案A：跳转到记录页面，并且刷新页面（适合keep‑alive缓存页面）
                    // 先跳别的空页面再跳回来，触发页面刷新
                    this.$router.replace('/redirect').then(() => {
                        this.$router.replace(this.lastPageUrl)
                    })
                } else {
                    // 默认跳首页
                    this.$router.replace('/')
                }
            },
            toregister(e) {
                if (e < 4) {
                    this.identity = 0
                } else {
                    this.identity = 1
                }
                this.showLogin = false
                this.showfo = false
                this.showRe = true
            },
            toforgets(e) {
                if (e < 4) {
                    this.identity = 0
                } else {
                    this.identity = 1
                }
                this.showLogin = false
                this.showRe = false
                this.showfo = true
            }
        }
    }
</script>
<style>
    body {
        overflow: visible !important;
    }

    .nodatas {
        width: 314px;
        height: 236px;
    }

    .tpis {
        font-size: 14px !important;
        color: #666;
        text-align: left;
        margin-top: 8px;
        box-sizing: border-box;
        padding: 0 6px;
    }

    .bread {
        box-sizing: border-box;
        padding: 20px 0;
        width: 1460px;
        margin: 0 auto;
    }

    /* Edge、IE 密码框自带小眼睛 */
    input[type="password"]::-ms-reveal {
        display: none !important;
    }

    /* 清除input自带清除叉号 */
    input::-ms-clear {
        display: none !important;
    }

    /* webkit浏览器自动填充相关图标一并隐藏 */
    input[type="password"]::-webkit-contacts-auto-fill-button,
    input[type="password"]::-webkit-credentials-auto-fill-button {
        visibility: hidden;
        display: none !important;
        pointer-events: none;
        height: 0;
        width: 0;
    }

    .eyes {
        width: 20px !important;
        height: 20px !important;
        cursor: pointer !important
    }

    .hea50 {
        height: 150px;
        /* background: pink; */
    }

    .bluebtn {
        box-sizing: border-box;
        padding: 11px;
        background: #DEEEFF;
        border-radius: 8px;
        font-size: 13px;
        color: #007AFF;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        display: inline-block;
    }

    .bluebtn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }

    .el-container {
        display: block !important;
    }

    .greenbtn {
        box-sizing: border-box;
        padding: 11px;
        background: #E8F6EB;
        border-radius: 8px 8px 8px 8px;
        font-size: 13px;
        color: #4CC864;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        display: inline-block;
    }

    .redbtn {
        box-sizing: border-box;
        padding: 11px;
        background: #FBECED;
        border-radius: 8px 8px 8px 8px;
        font-size: 13px;
        color: #FF1024;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        display: inline-block;
    }

    .redbtn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }

    .greenbtn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }

    .topparts {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 12890 !important;
    }

    .blank {
        height: 150px;
        background: #fff;
    }

    .gn .el-menu--horizontal .el-menu-item {
        padding: 0 0 !important;
    }

    html {
        scrollbar-width: none;
        /* Firefox */
    }

    html::-webkit-scrollbar {
        display: none !important;
        /* Chrome Safari Edge */
    }

    html,
    body {
        -ms-overflow-style: none;
        /* IE */
        /* overflow-x: hidden; */
        /* 如果需要隐藏横向滚动条 */
    }

    .el-main {
        padding: 0 !important;
        position: static;
        top: 150px;
    }

    .caItem {
        margin-right: 40px;
        font-size: 16px !important;
        color: #4E5366;
        margin-bottom: 10px !important;
    }

    .cateName {
        font-weight: 600;
        font-size: 20px !important;
        color: #222222;
        margin-right: 40px;
    }

    .checkmopre {
        width: 108px !important;
        /* height: 17px; */
    }

    body {
        width: 1920px !important;
    }

    .el-menu-item:hover {
        color: #007AFF !important;
    }

    .el-submenu__title:hover {
        color: #007AFF !important;
    }

    .el-menu--popup {
        min-width: 115px !important;
    }

    .el-menu--popup>>>.el-menu-item {
        height: 54px !important;
        line-height: 54px !important;
        text-align: center !important;
        border-bottom: 2px dashed #d9d9d9 !important;
    }

    .el-menu-item:hover {
        color: #409EFF !important;
    }

    .el-submenu__title:hover {
        color: #409EFF !important;
    }

    .el-button {
        display: inline-flex !important;
        justify-content: center !important;
        align-items: center !important;
    }

    /* 
    .el-menu--horizontal .el-menu .el-menu-item {
        color: #409EFF !important;
        height: 54px !important;
        border-bottom: 2px dashed #d9d9d9 !important;
    } */

    .single {
        white-space: nowrap;
        /* 强制不换行 */
        overflow: hidden;
        /* 隐藏溢出内容 */
        text-overflow: ellipsis;
        /* 溢出显示省略号 */
        min-width: 0;
    }

    .multy2 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        /* 显示几行 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .multy3 {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        /* 显示几行 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* 全局页面滚动条 */
    ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background: #c5c8ce;
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #999;
    }

    /* Firefox */
    html {
        scrollbar-width: thin;
        scrollbar-color: #c5c8ce transparent;
    }



    .main-content {
        min-height: 52vh !important;
        background: #f8f8f8;
    }

    .el-container {
        display: block !important;
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        width: 100%;
        height: 100vh;
    }

    * {

        padding: 0;
        margin: 0;

    }

    .flx {
        display: flex;
    }

    .alc {
        align-items: center;
    }

    .jsb {
        justify-content: space-between;
    }

    .jsc {
        justify-content: center;
    }

    .cursor {
        cursor: pointer;
    }
</style>